import { render } from "./Destiny2View.vue?vue&type=template&id=2f38b250"
const script = {}

import "./Destiny2View.vue?vue&type=style&index=0&id=2f38b250&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__